<template>
  <div class="fund-size-worth">
    <div class="update-time">单位：港元</div>
    <VueEcharts :option="option" />
    <RkTable :data="worthData">
      <RkTableColumn prop="" label="周期" align="left"></RkTableColumn>
      <RkTableColumn prop="" label="净资产(港元)"></RkTableColumn>
      <RkTableColumn prop="" label="变动比例"></RkTableColumn>
    </RkTable>
  </div>
</template>

<script>
export default {
  inject: ['theme'],
  data() {
    return {
      worthData: []
    }
  },
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    option() {
      return {
        grid: {
          top: 20,
          bottom: 0,
          left: 0,
          right: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['Mon', 'Tue', 'Wed', 'Thu'],
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: this.theme['--border-color-1']
            }
          },
          axisLabel: {
            color: this.theme['--font-color-3']
          }
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            show: false
          },
          splitLine: {
            show: false
          }
        },
        series: [
          {
            data: [120, 200, 150, 80],
            type: 'bar',
            barMaxWidth: 30,
            itemStyle: {
              color: '#FF9933'
            }
          }
        ]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.fund-size-worth {
  padding: var(--edge-padding);
  background: var(--bg-color-2);
  .update-time {
    text-align: right;
    font-size: 13px;
    color: var(--font-color-3);
  }
}
</style>
